module.exports = __webpack_public_path__ + "./images/686215f1f5c8d3e05afd0e6a06646cb5.webp";